import React, { useEffect, useState } from "react";
import "./PricingSection.scss";
import { useFormik } from "formik";
import * as bootstrap from "bootstrap";
import * as Yup from "yup";
import {
  getAllMarkupPrices,
  addMarkUp,
  deleteMarkupPrice,
  updateMarkUp,
} from "../../../../requests/markupPriceAPI";
import { LocalStorageKeys } from "../../../../constants/LocalStorageKeys";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  getAllPacakges,
  getSupportedLocations,
} from "../../../../requests/packagesApi";
const PricingSection = () => {
  var user = localStorage.getItem(LocalStorageKeys.USER_DETAILS);

  const navigate = useNavigate();
  const [markups, setMarkups] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [esimCoverage, setEsimCoverage] = useState("");
  const [country, setCountry] = useState([]);
  const [region, setRegion] = useState([]);

  const [pacakges, setPackages] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");

  const getValidLocations = async () => {
    try {
      const response = await getSupportedLocations();
      console.log(response?.obj?.locationList);

      if (response?.obj?.locationList) {
        const regions = [];
        const countries = [];

        response.obj.locationList.forEach((location) => {
          if (location.subLocationList && location.subLocationList.length > 0) {
            regions.push(location);
          } else {
            countries.push({
              name: location.name,
              code: location.code,
            });
          }
        });

        setRegion(regions);
        setCountry(countries);
      }
    } catch (error) {
      console.error("Error fetching valid locations:", error);
    }
  };
  const getAllPacakgesEsim = async () => {
    try {
      const requestPayload = {};

      if (selectedLocation) requestPayload.locationCode = selectedLocation;
      else if (selectedRegion) requestPayload.locationCode = selectedRegion;
      else if (esimCoverage) requestPayload.locationCode = esimCoverage;
      const response = await getAllPacakges(requestPayload);
      const fullList = response?.obj?.packageList || [];
      const firstTen = fullList?.slice(0, 10);
      setPackages(firstTen);
    } catch (error) {}
  };
  const getMarkupPrices = async () => {
    try {
      const result = await getAllMarkupPrices();
      const transformedMarkups = result?.map((item) => ({
        id: item?._id,
        vendor_name: item.vendorName ?? "",
        service_type: item.serviceType ?? "",
        data: item.data != null ? `${item.data} GB` : "-",
        markup: `${item.markUpPercentage}%`,
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        action: <img src="/images/icons/pen.svg" alt="icon" />,
        img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
        selected: false,
      }));

      setMarkups(transformedMarkups);
    } catch (error) {}
  };
  useEffect(() => {
    getMarkupPrices();
    getValidLocations();
  }, []);
  useEffect(() => {
    getAllPacakgesEsim();
  }, [selectedLocation, selectedRegion, esimCoverage]);
  // Is header checkbox checked?
  const allChecked = markups?.every((row) => row?.selected);

  // Toggle all markups
  const handleSelectAll = () => {
    const newValue = !allChecked;
    setMarkups(markups.map((row) => ({ ...row, selected: newValue })));
  };

  const handleRowSelect = (index) => {
    const updated = [...markups];
    updated[index].selected = !updated[index].selected;
    setMarkups(updated);
  };

  const userFormik = useFormik({
    initialValues: {
      serviceType: "",
      vendor: "",
      data: "",
      percentage: "",
    },
    validationSchema: Yup.object({
      serviceType: Yup.string().required("Please select a service type"),

      vendor: Yup.string(), // Optional

      data: Yup.number().typeError("Must be a number"),

      percentage: Yup.number()
        .typeError("Must be a number")
        .min(0, "Must be at least 0")
        // .max(100, "Cannot exceed 100")

        .required("percentage is required"),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          vendorName: values.vendor,
          serviceType: values.serviceType,
          data: values.data ? parseFloat(values.data) : null,
          markUpPercentage: values.percentage
            ? parseFloat(values.percentage)
            : 0,
          // status: values.status.toLowerCase(),
          userId: user,
        };

        const response = await addMarkUp(payload);

        if (response.status === 201) {
          getMarkupPrices();
          userFormik.resetForm();
          toast.success("Data Added Successfully!");
        } else if (response.status === 400) {
          userFormik.resetForm();
          toast.error("A markup already exists for provided category.");
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          toast.error("A markup already exists for provided category.");
        } else {
          toast.error("Something Went Wrong!");
        }

        console.error("Error adding markup:", error);
      } finally {
        userFormik.resetForm();

        const dismissButton = document.getElementById(
          "pricingManagementModalDismissButton"
        );
        if (dismissButton) {
          dismissButton.click();
        }
      }
    },
  });
  const [selectedUpdateId, setSelectedUpdateId] = useState("");

  const updateFormik = useFormik({
    initialValues: {
      serviceType: "",
      vendor: "",
      data: "",
      percentage: "",
    },
    validationSchema: Yup.object({
      serviceType: Yup.string().required("Please select a service type"),
      vendor: Yup.string(),
      data: Yup.number().typeError("Must be a number"),
      percentage: Yup.number()
        .typeError("Must be a number")
        .min(0, "Must be at least 0")
        // .max(100, "Cannot exceed 100")
        .required("percentage is required"),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          vendorName: values.vendor,
          serviceType: values.serviceType,
          data: values.data ? parseFloat(values.data) : null,
          markUpPercentage: values.percentage
            ? parseFloat(values.percentage)
            : 0,
          userId: user,
        };

        const response = await updateMarkUp(payload, selectedUpdateId);

        if (response) {
          getMarkupPrices();
          toast.success("Data Updated Successfully!");
        }
      } catch (error) {
        console.error("Error updating markup:", error);
        toast.error("Something Went Wrong!");
      } finally {
        updateFormik.resetForm();
        const dismissButton = document.getElementById(
          "updateMarkupModalDismissButton"
        );
        if (dismissButton) {
          dismissButton.click();
        }
      }
    },
  });
  const deleteMarkup = async () => {
    try {
      const response = await deleteMarkupPrice(deleteId);
      if (response) {
        getMarkupPrices();
        toast.success("Data Deleted Successfully!");
      }
    } catch (error) {
      console.error("Error deleting markup:", error);
      toast.error("Something Went Wrong!");
    } finally {
      const dismissButton = document.getElementById(
        "deleteMarkupModalDismissButton"
      );
      if (dismissButton) {
        dismissButton.click();
      }
    }
  };
  useEffect(() => {
    console.log("running useEffect in MainPage");

    const token = localStorage.getItem("teleport_admin_token");
    console.log(token);

    if (!token) {
      toast.error("Token expired. Please log in again.");
      navigate("/admin-login");
    }
  }, []);
  return (
    <section className="pricing-page-section">
      <div className="search-input">
        <h5 className="form-title">Pricing Management</h5>
        <button
          className="custom-btn"
          data-bs-toggle="modal"
          data-bs-target="#pricingManagementModal"
        >
          Add Markup
        </button>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th>
              <th>Vendor Name</th>
              <th>Service Type</th>
              <th>Data</th>
              <th>Markup Percentage</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {markups?.map((row, i) => (
              <tr key={i}>
                {console.log("markups", markups)}
                <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td>
                <td>{row.vendor_name}</td>
                <td>{row.service_type}</td>
                <td>{row.data}</td>
                <td>{row.markup}</td>
                <td>{row.status}</td>
                <td>
                  <span className="action-link">
                    <div
                      data-bs-toggle="modal"
                      data-bs-target="#updateMarkupModal"
                      onClick={() => {
                        setSelectedUpdateId(row.id);
                        updateFormik.setValues({
                          vendor: row.vendor_name,
                          serviceType: row.service_type,
                          data: row.data === "-" ? "" : parseFloat(row.data),
                          percentage: parseInt(row.markup),
                        });
                      }}
                    >
                      {row.action}
                    </div>
                    <div
                      data-bs-toggle="modal"
                      data-bs-target="#cancelModal"
                      onClick={() => setDeleteId(row.id)}
                    >
                      {row.img}
                    </div>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="pricingManagementModal"
        tabIndex="-1"
        aria-labelledby="pricingManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content pricingManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Add Markup</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                  role="button"
                />
              </div>

              {/* ✅ Form Section */}
              <form className="user-info" onSubmit={userFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <strong className="mb-2">Select Service & Vendor</strong>
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="vendor"
                          placeholder="eSim"
                          value={userFormik.values.vendor}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Vendor (Optional)
                        </label>
                        {userFormik.touched.vendor &&
                          userFormik.errors.vendor && (
                            <div className="error">
                              {userFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="serviceType"
                          value={userFormik.values.serviceType}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          Service Type
                        </label>
                        {userFormik.touched.serviceType &&
                          userFormik.errors.serviceType && (
                            <div className="error">
                              {userFormik.errors.serviceType}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="esimCoverage"
                          value={esimCoverage}
                          onChange={(e) => {
                            setSelectedLocation("");
                            setSelectedRegion("");
                            setEsimCoverage(e.target.value);
                          }}
                        >
                          <option value="GL">Global</option>
                          <option value="!RG">Regional</option>
                          <option value="local">Local</option>
                        </select>
                        <label className="floating-label-text">
                          eSim Coverage
                        </label>
                      </div>
                    </div>
                    {esimCoverage == "local" ? (
                      <div className="col-md-6 p-2">
                        <div className="floating-label">
                          <select
                            name="selectedLocation"
                            value={selectedLocation}
                            onChange={(e) => {
                              setSelectedLocation(e.target.value);
                            }}
                          >
                            {country?.map((cont) => {
                              return (
                                <option value={cont?.code}>{cont?.name}</option>
                              );
                            })}
                          </select>
                          <label className="floating-label-text">Country</label>
                        </div>
                      </div>
                    ) : esimCoverage == "!RG" ? (
                      <div className="col-md-6 p-2">
                        <div className="floating-label">
                          <select
                            name="esimCoverage"
                            value={selectedRegion}
                            onChange={(e) => {
                              setSelectedRegion(e.target.value);
                            }}
                          >
                            {region?.map((cont) => {
                              return (
                                <option value={cont?.code}>{cont?.name}</option>
                              );
                            })}
                          </select>
                          <label className="floating-label-text">Country</label>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    <strong className="mb-2 mt-3">Markup Percentage</strong>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="data"
                          placeholder="000"
                          value={userFormik.values.data}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>GB</span>
                        <label className="floating-label-text">Data</label>
                        {userFormik.touched.data && userFormik.errors.data && (
                          <div className="error">{userFormik.errors.data}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="percentage"
                          placeholder="000"
                          value={userFormik.values.percentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.percentage &&
                          userFormik.errors.percentage && (
                            <div className="error">
                              {userFormik.errors.percentage}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive mb-4">
                  <table className="table table-striped vendor-info">
                    <thead className="table-dark">
                      <tr>
                        <th>
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              checked={allChecked}
                              onChange={handleSelectAll}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </th>
                        <th>GB</th>
                        <th>Days</th>
                        <th>Current Price</th>
                        <th>Markup Percentage</th>
                        <th>Display Price </th>
                      </tr>
                    </thead>
                    <tbody>
                      {pacakges?.map((row, i) => (
                        <tr key={i}>
                          {console.log(pacakges)}
                          <td>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                checked={row.selected}
                                onChange={() => handleRowSelect(i)}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </td>
                          <td>{(row?.volume / 1024 ** 3)?.toFixed(2)}</td>
                          <td>{row?.duration}</td>
                          <td>{(row?.retailPrice / 1000)?.toFixed(2)}$</td>
                          <td>{userFormik?.values?.percentage}%</td>
                          {console.log(row)}
                          <td>
                            {(() => {
                              const bytesPerGB = 1073741824; // 1 GB in bytes
                              const volume = row?.volume || 0;
                              const retailPrice = row?.retailPrice || 0;

                              // Convert package volume to GB (with 2 decimal precision for safety)
                              const volumeInGB = +(volume / bytesPerGB).toFixed(
                                2
                              );

                              // User inputs
                              const selectedData = Number(
                                userFormik?.values?.data ?? 0
                              ); // assume user enters in GB
                              const markupPercent = Number(
                                userFormik?.values?.percentage ?? 0
                              );

                              // Default price (no markup applied)
                              let finalPrice = retailPrice;

                              // ✅ Only apply markup if this package's GB matches the selected data
                              if (volumeInGB === selectedData) {
                                const markupAmount =
                                  (markupPercent / 100) * retailPrice;
                                finalPrice = retailPrice + markupAmount;
                              }

                              return `$${(finalPrice / 1000).toFixed(2)}`;
                            })()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn">
                    Add Markup
                  </button>
                </div>

                {/* Hidden close button */}
                <button
                  type="button"
                  className="d-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="pricingManagementModalDismissButton"
                ></button>
              </form>
              {/* ✅ Table Section */}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="updateMarkupModal"
        tabIndex="-1"
        aria-labelledby="updateMarkupModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content pricingManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Update Markup</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                  role="button"
                />
              </div>

              <form className="user-info" onSubmit={updateFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <strong className="mb-2">Select Service & Vendor</strong>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="vendor"
                          placeholder="eSim"
                          value={updateFormik.values.vendor}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Vendor (Optional)
                        </label>
                        {updateFormik.touched.vendor &&
                          updateFormik.errors.vendor && (
                            <div className="error">
                              {updateFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="serviceType"
                          value={updateFormik.values.serviceType}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          Service Type
                        </label>
                        {updateFormik.touched.serviceType &&
                          updateFormik.errors.serviceType && (
                            <div className="error">
                              {updateFormik.errors.serviceType}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="esimCoverage"
                          value={esimCoverage}
                          onChange={(e) => {
                            setSelectedLocation("");
                            setSelectedRegion("");
                            setEsimCoverage(e.target.value);
                          }}
                        >
                          <option value="GL">Global</option>
                          <option value="!RG">Regional</option>
                          <option value="local">Local</option>
                        </select>
                        <label className="floating-label-text">
                          eSim Coverage
                        </label>
                      </div>
                    </div>

                    {esimCoverage === "local" ? (
                      <div className="col-md-6 p-2">
                        <div className="floating-label">
                          <select
                            name="selectedLocation"
                            value={selectedLocation}
                            onChange={(e) =>
                              setSelectedLocation(e.target.value)
                            }
                          >
                            {country?.map((cont) => (
                              <option key={cont?.code} value={cont?.code}>
                                {cont?.name}
                              </option>
                            ))}
                          </select>
                          <label className="floating-label-text">Country</label>
                        </div>
                      </div>
                    ) : esimCoverage === "!RG" ? (
                      <div className="col-md-6 p-2">
                        <div className="floating-label">
                          <select
                            name="selectedRegion"
                            value={selectedRegion}
                            onChange={(e) => setSelectedRegion(e.target.value)}
                          >
                            {region?.map((cont) => (
                              <option key={cont?.code} value={cont?.code}>
                                {cont?.name}
                              </option>
                            ))}
                          </select>
                          <label className="floating-label-text">Region</label>
                        </div>
                      </div>
                    ) : null}

                    <strong className="mb-2 mt-3">Markup Percentage</strong>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="data"
                          placeholder="000"
                          value={updateFormik.values.data}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <span>GB</span>
                        <label className="floating-label-text">Data</label>
                        {updateFormik.touched.data &&
                          updateFormik.errors.data && (
                            <div className="error">
                              {updateFormik.errors.data}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="percentage"
                          placeholder="000"
                          value={updateFormik.values.percentage}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {updateFormik.touched.percentage &&
                          updateFormik.errors.percentage && (
                            <div className="error">
                              {updateFormik.errors.percentage}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table Section */}
                <div className="table-responsive mb-4">
                  <table className="table table-striped vendor-info">
                    <thead className="table-dark">
                      <tr>
                        <th>
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              checked={allChecked}
                              onChange={handleSelectAll}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </th>
                        <th>GB</th>
                        <th>Days</th>
                        <th>Current Price</th>
                        <th>Markup Percentage</th>
                        <th>Display Price </th>
                      </tr>
                    </thead>
                    <tbody>
                      {pacakges?.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                checked={row.selected}
                                onChange={() => handleRowSelect(i)}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </td>
                          <td>{(row?.volume / 1024 ** 3)?.toFixed(2)}</td>
                          <td>{row?.duration}</td>
                          <td>{(row?.retailPrice / 1000)?.toFixed(2)}$</td>
                          <td>{updateFormik?.values?.percentage}%</td>
                          <td>
                            {(() => {
                              const bytesPerGB = 1073741824; // 1 GB in bytes
                              const volume = row?.volume || 0;
                              const retailPrice = row?.retailPrice || 0;

                              // Convert package volume into GB (2 decimal precision)
                              const volumeInGB = +(volume / bytesPerGB).toFixed(
                                2
                              );

                              // User inputs
                              const selectedData = Number(
                                updateFormik?.values?.data ?? 0
                              ); // user-entered GB
                              const markupPercent = Number(
                                updateFormik?.values?.percentage ?? 0
                              );

                              // Default price = retailPrice
                              let finalPrice = retailPrice;

                              // ✅ Apply markup only if package GB matches the form value
                              if (volumeInGB === selectedData) {
                                const markupAmount =
                                  (markupPercent / 100) * retailPrice;
                                finalPrice = retailPrice + markupAmount;
                              }

                              return `$${(finalPrice / 1000).toFixed(2)}`;
                            })()}
                          </td>
                          {/* <td>
                            {(() => {
                              const bytesPerGB = 1073741824;
                              const volume = row?.volume || 0;
                              const retailPrice = row?.retailPrice || 0;
                              const markupPercent = Number(
                                updateFormik?.values?.percentage ?? 0
                              );

                              const gbCount = volume / bytesPerGB;
                              const markupAmount =
                                (markupPercent / 100) * gbCount * retailPrice;
                              const markupPrice = Math.ceil(
                                retailPrice + markupAmount
                              );

                              return `$${(markupPrice / 1000).toFixed(2)}`;
                            })()}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn">
                    Update Markup
                  </button>
                </div>

                <button
                  type="button"
                  className="d-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="updateMarkupModalDismissButton"
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <div
        className="modal fade"
        id="updateMarkupModal"
        tabIndex="-1"
        aria-labelledby="updateMarkupModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content pricingManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Update Markup</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="user-info" onSubmit={updateFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <strong className="mb-2">Select Service & Vendor</strong>
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="vendor"
                          placeholder="eSim"
                          value={updateFormik.values.vendor}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Vendor (Optional)
                        </label>
                        {updateFormik.touched.vendor &&
                          updateFormik.errors.vendor && (
                            <div className="error">
                              {updateFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="serviceType"
                          value={updateFormik.values.serviceType}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          serviceType
                        </label>
                        {updateFormik.touched.serviceType &&
                          updateFormik.errors.serviceType && (
                            <div className="error">
                              {updateFormik.errors.serviceType}
                            </div>
                          )}
                      </div>
                    </div>

                    <strong className="mb-2 mt-3">Markup Percentage</strong>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="data"
                          placeholder="000"
                          value={updateFormik.values.data}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <span>GB</span>
                        <label className="floating-label-text">Data</label>
                        {updateFormik.touched.data &&
                          updateFormik.errors.data && (
                            <div className="error">
                              {updateFormik.errors.data}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="percentage"
                          placeholder="000"
                          value={updateFormik.values.percentage}
                          onChange={updateFormik.handleChange}
                          onBlur={updateFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {updateFormik.touched.percentage &&
                          updateFormik.errors.percentage && (
                            <div className="error">
                              {updateFormik.errors.percentage}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn">
                    Update Markup
                  </button>
                </div>
                <button
                  type="button"
                  className="d-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="updateMarkupModalDismissButton"
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="modal fade"
        id="cancelModal"
        tabIndex="-1"
        aria-labelledby="cancelModalLabel"
        aria-hidden="true"
      >
        <div
          id="deleteMarkupModal"
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content markup-modal">
            <div className="modal-body">
              <h5 className="modal-title">Delete Markup</h5>
              <p>Are you sure you want to remove this mark up. </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  deleteMarkup();
                }}
                type="button"
                className="btn"
              >
                Delete
              </button>
            </div>
            <button
              type="button"
              className="d-none"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="deleteMarkupModalDismissButton"
            ></button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
